import React from 'react';
import ReactDOM from 'react-dom';

const Portal = ({ children }) => {
  const modalRoot = document.body;
  return ReactDOM.createPortal(children, modalRoot);
};

export default Portal;
